import { atom } from 'nanostores';

/**
 * @typedef {{
 *  id?: number;
 *  name?: string | null;
 *  email?: string | null;
 *  email_verified_at?: string | null;
 *  created_at?: string;
 *  updated_at?: string;
 *  email_verification_hash?: string | null;
 *  last_name?: string | null;
 *  customer_type?: string;
 *  password_reset_code?: string | null;
 *  password_reset_code_expires_at?: string | null;
 * }} TUserData
 */

export class UserStore {
  /** @type {TUserData | null} */
  user = null;

  $name = atom('');

  $lastName = atom('');

  $isAuthorized = atom(false);

  store;

  constructor(store) {
    this.store = store;
  }

  authorize = async () => {
    this.store.loadingStore.lock('auth', 'init');

    try {
      if (window.localStorage.getItem('token')) {
        const response = await this.store.apiStore.api.getAuthUserData();
        this.setUser(response.data);
      }
    } catch (error) {
      this.signOut();
    }

    this.store.loadingStore.unlock('auth');

    return this.user;
  };

  signOut = () => {
    this.setUser(null);
    window.localStorage.removeItem('token');
  };

  setUser = (user) => {
    this.user = user;
    this.$isAuthorized.set(!!user);
    if (user) {
      this.$name.set(user.name ?? '');
      this.$lastName.set(user.last_name ?? '');
    }
  };
}
